import Loading from 'components/shared-components/Loading'
import { Suspense, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { onBlankLayout } from 'store/slices/themeSlice'

const AppRoute = ({
  component: Component,
  routeKey,
  blankLayout,
  ...props
}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const isBlank = blankLayout ? true : false

    dispatch(onBlankLayout(isBlank))
  }, [blankLayout, dispatch])

  return (
    <Suspense fallback={<Loading cover='content' />}>
      <Component {...props} />
    </Suspense>
  )
}

export default AppRoute
